import { format } from "date-fns";
import { es } from "date-fns/locale";
import React from "react";
import { useLocation } from "react-router-dom";

const Note = () => {
  let location = useLocation();
  const { item } = location.state;
  const { nota, emotion, hora } = item.data;
  const timeToString = (fecha) => {
    const date = new Date(fecha);
    return date.toISOString().split("T")[0];
  };
  return (
    <>
      <div>
        {`Fecha: 
        ${format(new Date(timeToString(hora.toDate())), "PPP", {
          locale: es,
        })}`}
      </div>
      <div>
        {`Hora:
        ${hora.toDate().toLocaleTimeString("en-US", {
          hour: "2-digit",
          minute: "2-digit",
        })}`}
      </div>
      <div>{`Emoción del día: ${emotion}`}</div>
      <div>{` Pensamiento del día: ${nota}`}</div>
    </>
  );
};

export default Note;
